import React from 'react';
import { Alert, Box, Typography } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to an error reporting service if needed
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={4}>
          <Alert severity="error">Something went wrong in the application.</Alert>
          <Typography variant="body2" mt={2}>{this.state.error?.toString()}</Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
